import { createContext, useEffect, useState } from "react";
import CryptoJS from "crypto-js";
import axiosClient from "../axios-client";
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext(null);

export default function Context({ children }) {
  const [userCountryCode, setUserCountryCode] = useState(null);

  const secretKeyEnv = process.env.REACT_APP_SECRET_KEY;
  const navigate = useNavigate()
  const getEncryptionKey = () => {
    const deviceInfo = navigator.userAgent;

    const secretKey = secretKeyEnv;
    return secretKey + deviceInfo;
  };
  const encryptToken = (token) => {
    const key = getEncryptionKey();
    return CryptoJS.AES.encrypt(token, key).toString();
  };
  const decryptToken = (encryptedToken) => {
    try {
      const key = getEncryptionKey();
      const bytes = CryptoJS.AES.decrypt(encryptedToken, key);
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      // console.error("Error decrypting token:", error);
      return null;
    }
  };
  const [user, setUser] = useState({});
  const [profile, setProfile] = useState({});
  const [profileId, _setProfileId] = useState(() => {
    return localStorage.getItem("profileId") || null;
  });
  const [token, _setToken] = useState(() => {
    const encryptedToken = localStorage.getItem("U_T");
    return encryptedToken ? decryptToken(encryptedToken) : null; // Decrypt the token when loading
  });
  const setProfileId = (id) => {
    if (id) {
      localStorage.setItem("profileId", id);
    } else {
      localStorage.removeItem("profileId");
    }
    _setProfileId(id);
  };

  const fetchProfile = async (id) => {
    try {
      const response = await axiosClient.get(`/profiles/${id}/`);
      setProfile(response.data);
    } catch (err) {
      // console.error(err);
    }
  };

  useEffect(() => {
    if (profileId) {
      fetchProfile(profileId);
    }
  }, [profileId]);

  useEffect(() => {
    if (token) {
      axiosClient
        .get("auth/user/")
        .then(({ data }) => {
          setUser(data);
          // if(!data.has_active_subscription){
          //   navigate('/abonnement')
          // }else  navigate('/profile')
        })
        .catch((err) => {
        });
      // axiosClient.get("/get-ip-and-country/")
      //   .then(response => {
      //     setUserCountryCode(response.data.code);
      //     localStorage.setItem("U_C", response.data.code);
      //   })
      //   .catch(error => {
      //     // console.error("Error fetching country:", error)
      //   }
      //   );
    }
  }, [token]);


  const getCountryCode = async () => {
    let storedCountryData;
    try {
      storedCountryData = localStorage.getItem("U_C");

      if (storedCountryData) {
        setUserCountryCode(storedCountryData);
      }
    } catch (error) {
      console.error("Error handling IP and country data:", error);
    }

    // Fetch from API regardless of whether data was found in localStorage
    try {
      if (storedCountryData) {
        axiosClient.get('get-ip-and-country/').then((response) => {
          if (response?.data?.code) {
            localStorage.setItem("U_C", response.data.code);
            setUserCountryCode(response.data.code);
          }

          // console.log("response.data.code", response.data.code);

        }).catch((error) => {
          console.error("Error handling IP and country data:", error);
        });


      } else {
        const response = await axiosClient.get('get-ip-and-country/');

        if (response?.data?.code) {
          setUserCountryCode(response.data.code);
          // Store the response in SecureStore
          await localStorage.setItem("U_C", response.data.code);
        }

      }

    } catch (error) {
      console.error("Error fetching country data:", error);
    }
  };

  useEffect(() => {
    getCountryCode();
  }, [userCountryCode, token]);


  const setToken = (token) => {
    if (token) {
      const encryptedToken = encryptToken(token); // Encrypt the token
      localStorage.setItem("U_T", encryptedToken);
    } else {
      localStorage.removeItem("U_T");
    }
    _setToken(token);
  };

  function updateUser() {
    axiosClient
      .get("auth/user/")
      .then(({ data }) => {
        setUser(data);

      })
      .catch((err) => {
        // console.error(err);
      });

  }


  return (
    <AuthContext.Provider value={{
      user,
      setUser,
      setProfileId,
      profileId,
      profile,
      setProfile,
      token,
      setToken,
      updateUser,
      userCountryCode,
      setUserCountryCode
    }}>
      {children}
    </AuthContext.Provider>
  );
}
